import { Component, OnInit } from '@angular/core';
import * as moment from 'moment-timezone';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { UserChatCrm } from 'src/app/interfaces/userchatcrm';
import { CountryService } from 'src/app/service/country.service';
import { Country } from 'src/app/interfaces/countryData';
import { LoginService } from 'src/app/service/login.service';

import { UsersService } from 'src/app/service/users.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
  providers: [MessageService]
})

export class AccountDetailsComponent implements OnInit {

  stateOptions: Object[] = [{ label: 'Administrador', value: 'administrador' }, { label: 'Supervisor', value: 'supervisor' }, { label: 'Operador', value: 'operador' }];
  account: string = "administrador";
  public timeZones: string[];
  public cTZ: string | undefined;
  countries: Country[] = [];
  public cCountry: string | undefined;
  language: string[] = ["Ingles", "Frances", "Español"];
  public lang: string | undefined;
  usuario: UserChatCrm


  public nombreCompleto: string = "";
  public correo: string = "";
  public tipoCuenta: string = "";

  rol: string = "";
  idrol!:number;

  constructor(private countryService: CountryService, private messageService: MessageService,
    private userService: UsersService, private loginService: LoginService,
    private translate: TranslateService, private route: ActivatedRoute) {
    this.timeZones = moment.tz.names();
    this.usuario = loginService.chatCrmUser
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit(): void {
    this.idrol = this.loginService.chatCrmUser.idRol;
    this.countryService.getCountries().then(data => this.countries = data);
    this.getInfoCuenta()
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }
  addSingle() {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.instant('SUCCESS_ACCOUNT') });
  }

  async getInfoCuenta() {
    const isCustomer = this.usuario.idRol === 1;
    const response = await this.userService.getInfoCuenta(this.usuario.id, isCustomer);
    const name = response.data.name || "";
    const lastName = response.data.lastName || "";
    
    this.nombreCompleto = `${name} ${lastName}`;
    this.correo = response.data.email || "";
    this.tipoCuenta = response.data.rol || "";
  }


}
